export default {
    topics: [
        {
            title: ' File (Class) ',
            href: 'c-File.html',
            attributes: { 'data-id': 'c-File' },
            menu: { hasChildren: false },
            tocID: 'c-File-d66e4861',
            next: 'c-File-d66e4861',
        },
        {
            title: ' MemoryBuffer (Class) ',
            href: 'c-MemoryBuffer.html',
            attributes: { 'data-id': 'c-MemoryBuffer' },
            menu: { hasChildren: false },
            tocID: 'c-MemoryBuffer-d66e5063',
            next: 'c-MemoryBuffer-d66e5063',
        },
        {
            title: ' ZipFile (Class) ',
            href: 'c-ZipFile.html',
            attributes: { 'data-id': 'c-ZipFile' },
            menu: { hasChildren: false },
            tocID: 'c-ZipFile-d66e5232',
            next: 'c-ZipFile-d66e5232',
        },
    ],
};

